/**
 * Admin page for viewing bindcard transactions, and remediating failed charges.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Button, Checkbox, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import { format, isValid, subMonths, startOfDay, addDays } from 'date-fns';
import { TablePagination } from '@mui/material';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';
import PageTitle from '../ui/PageTitle';

const abEnvironment = new AbEnvironment();
const BindCardTransactionsQuery = graphql`
query BindCardTransactionsQuery($mode: Int, $provisioningAccount: String, $usingAccount: String, $appName: String, $startTs: Datetime, $endTs: Datetime, $first: Int, $offset: Int) {
  lookupbindcardtransactions(mode: $mode, provisioningAccount: $provisioningAccount, usingAccount: $usingAccount, appName: $appName, startTs: $startTs, endTs: $endTs, first: $first, offset: $offset) {
    totalCount
    nodes {
      bcTime
      bcTransactionId
      bcAmount
      pAccountId
      provisioningAcct
      uAccountId
      usingAcct
      appName
      paymentOrder
      bTime
      bTransactionId
      bSource
      bDesc
      bExtId
      bAccountId
      bAmount
      cTime
      cTransactionId
      cSource
      cExtId
      cAmount
      dTransactionId
      dAmount
      resellerPayingFee
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    paper: {
      /*
      [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
      */
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      //maxWidth: 1400,
      width: 2000,
      marginTop: 16,
    },
    flex: {
      flex: 1,
    },
  });

class BindCardCharges extends Component {

  constructor(props) {
    super(props);

    let bctModeAlpha = localStorage.getItem('bctMode');
    let bctMode = 0;
    if (!bctModeAlpha) {
     bctMode = parseInt(bctModeAlpha, 10);
    }

    let bctProvisioner = localStorage.getItem('bctProvisioner');
    if (!bctProvisioner) {
      bctProvisioner = '';
    }
    let bctUsingAccount = localStorage.getItem('bctUsingAccount');
    if (!bctUsingAccount) {
      bctUsingAccount = '';
    }
    let bctAppName = localStorage.getItem('bctAppName');
    if (!bctAppName) {
      bctAppName = '';
    }

    // Default toDate
    let cToDate = new Date();
    let tDate = localStorage.getItem('cToDate');
    if (tDate != null) {
      cToDate = new Date(tDate);
    }
    //search toDate should be "start of next day"
    let searchToDateUtc = startOfDay(addDays(cToDate, 1)).toISOString();

    let cFromDate = new Date();
    let fDate = localStorage.getItem('cFromDate');
    if (fDate != null) {
      cFromDate = new Date(fDate);
    } else {
      cFromDate = subMonths(cToDate, 1);
    }
    //search fromDate is "start of day selected"
    let searchFromDateUtc = startOfDay(cFromDate).toISOString();

    this.state = {
      mode: bctMode,
      provisioningAccount: bctProvisioner,
      usingAccount: bctUsingAccount,
      appName: bctAppName, 
      startDate: cFromDate,
      queryStartDateUtc: searchFromDateUtc,
      endDate: cToDate,
      queryEndDateUtc: searchToDateUtc,
      page: 0,
      rowsPerPage: 10,
      bTransactionArr: []
    };  
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  setFromDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('cFromDate', vdate);
      let searchDateUtc = startOfDay(vdate).toISOString();
      this.setState({ startDate: vdate.toDateString(), queryStartDateUtc: searchDateUtc, page: 0 });
    }
  }

  setToDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('cToDate', vdate);
      let searchDateUtc = startOfDay(addDays(vdate, 1)).toISOString();
      this.setState({ endDate: vdate.toDateString(), queryEndDateUtc: searchDateUtc, page: 0  });
    }
  }

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  billTransaction(theTransaction) {
    const { callPartnerApi } = this.props.auth;

    let payload = {
      operation: "processChargeForTransaction",
      params: {
        bcTransactionId: theTransaction
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      window.location.reload();
    })
    .catch(resp => {
      window.location.reload();
    })
  }

  dunnTransaction(theTransaction) {
    const { callPartnerApi } = this.props.auth;

    let payload = {
      operation: "processDunningChargeForTransaction",
      params: {
        bcTransactionId: theTransaction
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      window.location.reload();
    })
    .catch(resp => {
      window.location.reload();
    })
  }

  getBillCbValue(tId) {
    for (let i=0; i<this.state.bTransactionArr.length; i++) {
      if (tId === this.state.bTransactionArr[i]) {
        return true;
      }
    }
    return false;
  }

  handleBillCbChange(tId) {
    for (let i=0; i<this.state.bTransactionArr.length; i++) {
      if (tId === this.state.bTransactionArr[i]) {
        // The id is in the array.  Remove it, and reset the state.
        let replacementArr = [];
        for (let j=0; j<this.state.bTransactionArr.length; j++) {
          if (j !== i) {
            replacementArr.push(this.state.bTransactionArr[j]);
          }
        }
        this.setState({ bTransactionArr: replacementArr});
        return;
      }
    }

    // Falling through here means add the id to the array
    let replacementArr = [];
    for (let j=0; j<this.state.bTransactionArr.length; j++) {
      replacementArr.push(this.state.bTransactionArr[j]);
    }
    replacementArr.push(tId);
    this.setState({ bTransactionArr: replacementArr});
    return;
  }

  billTransactions() {
    const { callPartnerApi } = this.props.auth;

    if (this.state.bTransactionArr.length === 0) {
      return;
    }

    let payload = {
      operation: "processChargeForTransactions",
      params: {
        bcTransactionIds: JSON.stringify(this.state.bTransactionArr)
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      window.location.reload();
    })
    .catch(resp => {
      window.location.reload();
    })
  }

  render() {
    const { isAuthenticated, logError, isAuthenticatedAppBind, needAssent } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (! isAuthenticatedAppBind())
    {
      return (
        <Redirect to='/home' />
      );
    }

    let pSearch = '%';
    if (this.state.provisioningAccount !== '')
    {
      pSearch = '%' + this.state.provisioningAccount + '%';
    }
    let uSearch = '%';
    if (this.state.usingAccount !== '')
    {
      uSearch = '%' + this.state.usingAccount + '%';
    }
    let aSearch = '%';
    if (this.state.appName !== '')
    {
      aSearch = '%' + this.state.appName + '%';
    }

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

    let billSelectedDisabled = true;
    if (this.state.bTransactionArr.length > 0) {
      billSelectedDisabled = false;
    }

    return (
      <div className={classes.root}>
        <PageTitle title="BindCard transactions" subtitle="Admin view of bindcard charges and payments."/>

        <Paper className={classes.paper}>
          <Grid container spacing={2} alignItems='center' style={AppBindStyles.searchContainerOnPaper}>
            <Grid item>
              <SearchField
                id="provisioningAccount"
                label="Search by provisioner"
                value={this.state.provisioningAccount}
                onChange={this.handleChange('provisioningAccount')}
              />
            </Grid>
            <Grid item>
              <SearchField
                id="appName"
                label="Search by using account"
                value={this.state.usingAccount}
                onChange={this.handleChange('usingAccount')}
              />
            </Grid>
            <Grid item>
              <SearchField
                id="appName"
                label="Search by app"
                value={this.state.appName}
                onChange={this.handleChange('appName')}
              />
            </Grid>
            <Grid item>
              <div style={AppBindStyles.datePickerField}>
              <DatePicker
                maxDateMessage={AppBindStyles.datePickerMessageMax}
                autoOk
                label="From date"
                value={this.state.startDate}
                onChange={(date) => this.setFromDate(date) }
                format="YYYY-MM-DD"
                disableFuture
                renderInput={(params) => <TextField {...params} />}
              />
              </div>
            </Grid>
            <Grid item>
              <div style={AppBindStyles.datePickerField}>
              <DatePicker
                autoOk
                label="To date"
                value={this.state.endDate}
                onChange={(date) => this.setToDate(date) }
                format="YYYY-MM-DD"
                disableFuture
                renderInput={(params) => <TextField {...params} />}
              />
              </div>
            </Grid>
            <Grid item > 
              <FormControl variant="standard" className={classes.selectField}>
                <InputLabel>Transactions</InputLabel>
                <Select
                  value={this.state.mode }
                  onChange={(e) => { this.setState({ mode: e.target.value, page: 0 });} }
                  inputProps={{
                    name: 'mode',
                    id: 'mode',
                  }}
                >
                  
                  <MenuItem value={0}>All transactions</MenuItem>
                  <MenuItem value={1}>Unbilled Only</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Button color="primary" 
                      variant="outlined"
                      disabled={billSelectedDisabled}
                      onClick={() => {this.billTransactions();}}>
                Bill selected
              </Button>
            </Grid>
          </Grid>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={BindCardTransactionsQuery}
            variables={{mode: this.state.mode,
                        provisioningAccount: pSearch,
                        usingAccount: uSearch,
                        appName: aSearch,
                        startTs: this.state.queryStartDateUtc,
                        endTs: this.state.queryEndDateUtc,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {

                localStorage.setItem('bctMode', this.state.mode);
                localStorage.setItem('bctProvisioner', this.state.provisioningAccount);
                localStorage.setItem('bctUsingAccount', this.state.usingAccount);
                localStorage.setItem('bctAppName', this.state.appName);           

                // Determine offset information
                totalCount = props.lookupbindcardtransactions.totalCount;
                let thenodes = props.lookupbindcardtransactions.nodes;
                let keyCounter = 1;

                return (
                  <div>
                    <Table>
                      <TableHead className={classes.tblHead}>
                        <TableRow className={classes.tblHeadRow}>
                          <TableCell>Date</TableCell>
                          <TableCell>Transaction</TableCell>
                          <TableCell>Provisioning</TableCell>
                          <TableCell>Using</TableCell>
                          <TableCell>App</TableCell>
                          <TableCell align="right">Amount</TableCell>
                          <TableCell></TableCell>
                          <TableCell>Bill Date</TableCell>
                          <TableCell>Source</TableCell>
                          <TableCell>Desc</TableCell>
                          <TableCell>ExtId</TableCell>
                          <TableCell align="right">B Amt</TableCell>
                          <TableCell>Recv Date</TableCell>
                          <TableCell>Source</TableCell>
                          <TableCell>ExtId</TableCell>
                          <TableCell align="right">R Amt</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        { thenodes.map(n => {
                          //transaction times are un-zoned, specify is UTC
                          let bcdate = format(new Date(n.bcTime+'Z'), 'yyyy-MM-dd');
                          let bcc = Number(n.bcAmount)
                                    .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          let bdate = '';
                          if (n.bTime != null) {
                            bdate = format(new Date(n.bTime+'Z'), 'yyyy-MM-dd');
                          }
                          let bamt = Number(0)
                               .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          if (n.bAmount != null) {
                            bamt = Number(n.bAmount)
                              .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          }
                          let cdate = '';
                          if (n.cTime != null) {
                            cdate = format(new Date(n.bTime+'Z'), 'yyyy-MM-dd');
                          }
                          let camt = Number(0)
                               .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          if (n.cAmount != null) {
                            camt = Number(n.cAmount)
                              .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          }

                          // Determine if the dunning should be shown.  We need backup dunning if:
                          // - payment_order is 0 or 1
                          // - the provisioner paid for the the subscription (bAccountId === pAccountId)
                          // - the provisioner is not the user (pAccountId !== uAccountId)
                          // - dunning hasn't already been done
                          let showDunningButton = false;
                          if ((n.paymentOrder === 0 || n.paymentOrder === 1) && n.bAccountId === n.pAccountId && n.pAccountId !== n.uAccountId &&
                              n.cTransactionId != null && n.dTransactionId == null) {
                                if (!n.resellerPayingFee) {

                                  showDunningButton = true;
                                }
                          }

                          let theKey = n.bcTransactionId + '-' + keyCounter++;
                          let cbChecked = false;
                          if (n.bTransactionId == null) {
                            cbChecked = this.getBillCbValue(n.bcTransactionId);                            
                          }
                          return (
                            <TableRow key={theKey}>
                              <TableCell style={{whiteSpace: 'nowrap'}}>{bcdate}</TableCell>
                              <TableCell>{n.bcTransactionId}</TableCell>
                              <TableCell>{n.provisioningAcct}</TableCell>
                              <TableCell>{n.usingAcct}</TableCell>
                              <TableCell>{n.appName}</TableCell>
                              <TableCell align="right">{bcc}</TableCell>
                              {n.bTransactionId != null && showDunningButton === false &&
                              <TableCell colSpan={2} style={{whiteSpace: 'nowrap'}}>{bdate}</TableCell>}
                              {n.bTransactionId != null && showDunningButton === true &&
                              <TableCell colSpan={2}>
                                <Button color="primary" variant="outlined" onClick={() => {this.dunnTransaction(n.bcTransactionId);}}>Dunn</Button>
                              </TableCell>}
                              {n.bTransactionId == null &&
                              <React.Fragment>
                                <TableCell>
                                  <Checkbox name={n.bTransactionId} checked={cbChecked} onChange={() => {this.handleBillCbChange(n.bcTransactionId)}}/>
                                </TableCell>
                                <TableCell>
                                  <Button color="primary" variant="outlined" onClick={() => {this.billTransaction(n.bcTransactionId);}}>Bill</Button>
                                </TableCell>
                              </React.Fragment>}
                              <TableCell>{n.bSource}</TableCell>
                              <TableCell>{n.bDesc}</TableCell>
                              <TableCell>{n.bExtId}</TableCell>
                              {n.resellerPayingFee &&
                              <TableCell align="right"><Tooltip title={"reseller not passing fees through"} interactive placement="right"><div><i>{bamt}</i></div></Tooltip></TableCell>
                              }
                              {!n.resellerPayingFee &&
                              <TableCell align="right">{bamt}</TableCell>
                              }
                              <TableCell style={{whiteSpace: 'nowrap'}}>{cdate}</TableCell>
                              <TableCell>{n.cSource}</TableCell>
                              <TableCell>{n.cExtId}</TableCell>
                              <TableCell align="right">{camt}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <LoadingSpinner />
              );
            }}
          />
        </Paper>
      </div>
    );
  }
}

export default withStyles(styleSheet)(BindCardCharges);
